import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'de',
  lng: 'de',
  resources: {
    de: {
      translations: require('./locales/de/translations.json')
    },
    en: {
      translations: require('./locales/en/translations.json')
    },
    it: {
      translations: require('./locales/it/translations.json')
    },
    fr: {
      translations: require('./locales/fr/translations.json')
    },
    cz: {
      translations: require('./locales/cz/translations.json')
    },
    pl: {
      translations: require('./locales/pl/translations.json')
    },
    es: {
      translations: require('./locales/es/translations.json')
    },
    
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['de','en','it','fr','cz','pl','es'];

export default i18n;